import { render, staticRenderFns } from "./DatavizInfos.vue?vue&type=template&id=ed213236&scoped=true"
import script from "./DatavizInfos.vue?vue&type=script&lang=ts"
export * from "./DatavizInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed213236",
  null
  
)

export default component.exports